import { Component, Injector, OnDestroy } from '@angular/core';
import { Observable, Subscription, switchMap } from "rxjs";
import { KeyViewModel } from "../Model/KeyViewModel";
import { CreateKeyComponent } from "../create-key.component";
import { EditKeyComponent } from "../edit-key.coponent";
import { DriversViewModel } from "../../Drivers/models/DriversViewModel";
import { KeysService } from "../../../../services/keys.service";
import { KeyObjectsSyncDialogComponent } from "../keyobjects-sync-dialog/keyobjects-sync-dialog.component";
import { ExcelService } from "../../../../services/ExcelService";
import { GroupBaseAdminPanelComponent } from '../../base-admin-panel/group-base-admin-panel.component';
import { IManagableObject } from '../../IManagableObject';
import { DriversService } from "../../../../services/drivers.service";
import { map } from "rxjs/operators";
import { ObjectCreateViewModel } from "../../Objects/Models/ObjectViewModel";

@Component({
    selector: '[app-keys]',
    templateUrl: './keys.component.html',
    styleUrls: ['./keys.component.css'],
    standalone: false
})
export class KeysComponent extends GroupBaseAdminPanelComponent implements OnDestroy {

  public drivers: DriversViewModel[] = [];
  public trackers: ObjectCreateViewModel[] = [];
  private exportService: ExcelService;

  private subscription: Subscription;

  constructor(private keysService: KeysService, protected injector: Injector,
    private driversService: DriversService) {
    super(injector);
    this.exportService = injector.get(ExcelService);

    this.groupName = "KeysGroup";
    this.entityName = "Key";

    this.subscription = this.exportService.onImported.subscribe(data => {
      this.keysService.ExportKeys(data).subscribe(x => {
        this.Refresh();
        this.toastr.success(this.translate.instant('Import successful'));
      });
    })
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public getObjects(): KeyViewModel[] {
    return this.objects as KeyViewModel[];
  }
  protected Refresh() {


    this.keysService.GetKeys().pipe(
      switchMap((keys: KeyViewModel[]) =>
        this.driversService.GetAllDrivers().pipe(
          map((drivers: DriversViewModel[]) => {
            const driverMap = new Map<number, string>();
            drivers.forEach((driver: DriversViewModel) => driverMap.set(driver.Id, driver.Name));

            return keys.map((key: KeyViewModel) => {
              key.DriverName = driverMap.get(key.DriverId) || "";
              console.log(key);
              return key;
            });
          })
        )
      )
    ).subscribe((updatedKeys: KeyViewModel[]) => {
      this.objects = updatedKeys;
    });



    this.keysService.GetKeys()
      .subscribe(keys => {
        this.objects = keys;
      });

    this.keysService.GetGroups().subscribe(groups => {
      this.groupFilter.groups = groups;
    });
  }

  public openCreateModal() {
    this.prepareModal(CreateKeyComponent);
    this.componentRef.instance.open(new KeyViewModel());
  }

  public openEditModal(key: KeyViewModel) {
    this.prepareModal(EditKeyComponent);
    this.componentRef.instance.open(key);
  }

  protected doDeleteObject(id: number): Observable<any> {
    return this.keysService.DeleteKey(id);
  }

  openSyncKeysDialog(obj: KeyViewModel) {
    this.prepareModal(KeyObjectsSyncDialogComponent);
    this.componentRef.instance.keyId = obj.Id;
    this.componentRef.instance.open();
  }
  Incomingfile(event) {
    let file = event.target.files[0];
    if (file)
      this.exportService.Upload(file);
  }

  OpenExport() {
    this.exportService.exportJSONAsExcelFile(this.objects.filter(c => c.IsChecked));
  }

  protected doCreateGroup(input: IManagableObject): Observable<any> {
    return this.keysService.CreateGroup(input);
  }

  protected doDeleteGroup(input: IManagableObject): Observable<any> {
    return this.keysService.DeleteGroup(input);
  }
}
